module.exports = __webpack_public_path__ + "static/media/UW.ef91e660.png";